import React, { HTMLProps, forwardRef, useContext } from 'react';
import {
  Input, makeStyles, mergeClasses, tokens, shorthands,
} from '@fluentui/react-components';
import { SearchRegular } from '@fluentui/react-icons';

import { I18nContext } from '@bingads-webui-react/i18n-context';

import { I18n } from './types';

const useStyles = makeStyles({
  root: {
    alignSelf: 'flex-start',
    marginBottom: tokens.spacingVerticalXL,
    width: '260px',

    '& input': {
      '&:focus, &:hover': {
        ...shorthands.border(tokens.spacingHorizontalNone),
      },
    },
  },
});

export const Searchbox = forwardRef<HTMLInputElement, HTMLProps<HTMLInputElement>>(({ value, onChange }, ref) => {
  const i18n: I18n = useContext(I18nContext);
  const classes = useStyles();

  return (
    <Input
      ref={ref}
      className={mergeClasses('searchbox', classes.root)}
      aria-label={i18n.getString(_TL_('Search'))}
      // eslint-disable-next-line jsx-a11y/aria-props
      aria-description={i18n.getString(_TL_('Type to filter the full list of tools'))}
      contentBefore={<SearchRegular />}
      placeholder={i18n.getString(_TL_('Search'))}
      value={value as string}
      onChange={onChange}
    />
  );
});

export const SearchboxLiveRegion: React.FC<{
  count: number;
}> = ({ count }) => {
  const i18n: I18n = useContext(I18nContext);

  const label = count === 0
    ? i18n.getString(_TL_('No results found'))
    : i18n.getString(_TL_('{{count}} results found'), { count });

  return (
    <div
      className="searchbox-live-region"
      aria-live="polite"
      aria-label={label}
    />
  );
};
